'use strict';

var _ = require('lodash');
var GridColumnGroupFactory = function GridColumnGroupFactory(GridColumn, distanceUnitService) {
  function getGridId(data) {
    return _.first(data.gridId.split(':'));
  }
  var GridColumnGroup = function GridColumnGroup(data) {
    if (!_.isString(data.gridId)) {
      throw new Error('should provide gridId parameter');
    }
    this.id = getGridId(data) + '-' + data.groupId;
    this.gridId = getGridId(data);
    this.groupId = data.groupId;
    this.title = data.title;
    this.title = data.applyDistanceUnit ? distanceUnitService.applySuffix(data.title) : data.title;
    this.frozen = data.frozen || false;
    this.visible = data.visible || false;
    this.custom = data.custom || false;
    this.dataDrivenColumn = data.dataDrivenColumn;
    this.applyDistanceUnit = data.applyDistanceUnit;
    this.columns = this.transformColumns(data.columns, data.gridId);
    this.dynamicGroupName = data.dynamicGroupName;
    this.afterColumnPosition = data.afterColumnPosition;
    this.dynamicConfigDrivenColumn = data.dynamicConfigDrivenColumn;
  };
  GridColumnGroup.prototype.transformColumns = function (columns, gridId) {
    var self = this;
    return _.transform(columns, function (collection, data) {
      if (data instanceof GridColumn) {
        data.updateParent(self);
        collection.push(data);
      } else if (data.field) {
        data.gridId = data.gridId || gridId;
        var item = new GridColumn(data);
        item.updateParent(self);
        collection.push(item);
      }
    });
  };
  GridColumnGroup.prototype.isEmpty = function () {
    return _.isEmpty(this.columns);
  };
  GridColumnGroup.prototype.toExportFormat = function () {
    var data = this;
    var columns = [];
    if (!data.dataDrivenColumn) {
      columns = _.transform(data.columns, function (result, column) {
        return result.push(column.toExportFormat());
      });
    }
    return {
      groupId: data.groupId,
      title: data.title,
      frozen: data.frozen,
      visible: data.visible,
      custom: data.custom,
      applyDistanceUnit: this.applyDistanceUnit,
      dataDrivenColumn: !!data.dataDrivenColumn,
      columns: columns
    };
  };
  GridColumnGroup.prototype.toMergeFormat = function () {
    return {
      groupId: this.groupId,
      title: this.title,
      frozen: this.frozen,
      visible: this.visible,
      custom: this.custom,
      applyDistanceUnit: this.applyDistanceUnit,
      dataDrivenColumn: this.dataDrivenColumn,
      dynamicConfigDrivenColumn: this.dynamicConfigDrivenColumn,
      columns: _.transform(this.columns, function (result, column) {
        return result.push(column.toMergeFormat());
      })
    };
  };
  return GridColumnGroup;
};
GridColumnGroupFactory.$inject = ['GridColumnFactory', 'DistanceUnitService'];
module.exports = GridColumnGroupFactory;